<template>
  <div class="attachment-container">
    <el-row>
      <el-col :span="4">
        <AttachmentGroup :type="type" :editable="true" @change="groupChange" />
      </el-col>
      <el-col :span="20">
        <div class="list-container">
          <div class="list-actions">
            <!--动作组-->
            <el-button class="action-item" type="primary" icon="el-icon-edit" @click="show_upload">上传{{ type|getTypeName }}</el-button>
            <el-button icon="el-icon-edit" @click="show_regroup()">批量修改分组</el-button>
            <el-button icon="el-icon-delete" @click="show_delete(null)">批量删除</el-button>
            <el-button icon="el-icon-check" @click="select_all()">全选</el-button>
          </div>
          <div v-for="o in list" :key="o.id" :class="type === 'audio' ? 'list-item-audio' : 'list-item'">
            <el-image v-if="type === 'image'" :src="o.save_path+'!size=150X150'" :large="o.save_path" fit="cover" style="width:170px;height:170px;" preview="0"></el-image>
            <div v-if="type=='video'" class="video_box">
              <video :src="o.save_path" width="150" height="100" controls="controls"></video>
            </div>
            <div v-if="type=='audio'">
              <audio :src="o.save_path" controls style=" width: 100%;hight:40px" @onplayingNew="play(0)"></audio>
            </div>
            <div v-if="type === 'document'" :class="'image-' + o.extension_name.slice(1)" fit="cover" style="width:130px;height:150px;"></div>
            <div class="actions">
              <el-checkbox v-model="o.isChecked">{{ o.original_name }} </el-checkbox>
              <div style="padding-top:7px;font-size:14px;text-align: center;">
                <el-link type="primary" @click="show_rename(o)">修改</el-link> |
                <el-link type="primary" @click="show_delete(o)">删除</el-link> |
                <el-popover placement="bottom" width="286" trigger="click">
                  <el-input v-model="o.save_path" disabled size="small" style="width:200px;" />
                  <el-button v-clipboard:copy="o.save_path" v-clipboard:success="clipboardSuccess" size="small" type="primary">复制</el-button>
                  <el-link slot="reference" type="primary">链接</el-link>
                </el-popover>
              </div>
            </div>
          </div>
        </div>
        <!--分页-->
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :page-sizes="[12, 20, 50, 100]" :limit.sync="listQuery.limit" @pagination="loadData"></pagination>
      </el-col>
    </el-row>
    <!-- 修改名称分组弹窗 -->
    <el-dialog
      title="修改"
      :visible.sync="rename_show"
      width="30%"
    >
      <div>
        <el-input v-model="rename_title" type="text" />
        <el-select v-model="regroup_id" style="width:100%;margin-top:10px;" placeholder="请选择分组">
          <el-option
            v-for="item in groupList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rename_show = false">取 消</el-button>
        <el-button type="primary" @click="handleUpdate('rename')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改分组弹窗 -->
    <el-dialog
      title="设置分组"
      :visible.sync="regroup_show"
      width="30%"
    >
      <div>
        <el-select v-model="regroup_id" style="width:100%" placeholder="请选择分组">
          <el-option
            v-for="item in groupList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="regroup_show = false">取 消</el-button>
        <el-button type="primary" @click="handleUpdate('regroup')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增弹窗 -->
    <el-dialog
      title="本地上传"
      :visible.sync="upload_show"
      width="800px"
      @close="hidden_upload"
    >
      <div>
        <AttachmentUpload ref="Uploader" :type="type" :group="listQuery.group_id" @change="fileChane" />
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="hidden_upload">确 定</el-button> -->
      </span>
    </el-dialog>

  </div>
</template>

<script>
import api from '@/api/attachment'
import commonList from '@/utils/commonList'
import clipboard from '@/directive/clipboard/index.js' // use clipboard by v-directive
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import AttachmentGroup from '@/components/attachment/AttachmentGroup'// 类型分组
import AttachmentUpload from '@/components/attachment/AttachmentUpload'// 上传组件

export default {
  name: 'AttachmentImage',
  components: { Pagination, AttachmentGroup, AttachmentUpload },
  directives: { clipboard },
  filters: {
    getTypeName(val) {
      var name = ''
      switch (val) {
        case 'image':
          name = '图片'
          break
        case 'audio':
          name = '音频'
          break
        case 'video':
          name = '视频'
          break
        case 'document':
          name = '文档'
          break
      }
      return name
    }
  },
  mixins: [commonList],
  props: {
    type: { // 默认文件类型
      type: String,
      default: 'file'
    }
  },
  data() {
    return {
      rename_title: '',
      regroup_id: null,
      edit_mode: 'single', // 重命名/重分组 模式：批量
      current_edit_ids: [], // 当前编辑ID
      rename_show: false,
      regroup_show: false,
      upload_show: false,
      // api接口方法
      api,
      groupList: [],
      // 额外过滤条件
      listQuery: {
        group_id: 0,
        // type: 'image',
        limit: 12 // 页大小
      }
    }
  },
  watch: {
    type(newVal, oldVal) {
      this.$set(this.listQuery, 'type', newVal)
    }
  },
  created() {
    this.$set(this.listQuery, 'type', this.type)
    // this.loadData() // 页面加载创建时加载数据 -》修改成分组列表加载完触发
  },
  methods: {
    play(o) {
      console.log(o)
    },
    fileChane() { // 新文件上传成功后重新加载列表
      this.upload_show = false
      // this.$nextTick(res => {
      //   this.$refs.Uploader.clearFiles()
      // })
      this.loadData()
    },
    // 获取分组
    groupChange(group, list) {
      this.groupList = list
      this.listQuery.group_id = group.id
      this.listQuery.page = 1
      this.loadData()
    },
    // 弹框
    show_upload() {
      this.upload_show = true
    },
    hidden_upload() {
      this.upload_show = false
      this.$nextTick(res => {
        this.$refs.Uploader.clearFiles()
      })
    },
    show_rename(item) { // 重命名
      this.rename_show = true
      this.rename_title = item.original_name
      this.regroup_id = item.group_id
      this.current_edit_ids = [item.id]
    },
    show_regroup() { // 批量分组
      this.regroup_id = null
      this.rename_title = null
      this.current_edit_ids = this.getSelectIds()
      if (this.current_edit_ids.length > 0) {
        this.regroup_show = true
      } else {
        this.$message({ message: '请选择要进行重分组的数据', type: 'warning' })
      }
    },
    show_delete(item) { // 删除/批量删除
      if (item) {
        this.current_edit_ids = [item.id]
        this.handleDelete()
      } else {
        this.current_edit_ids = this.getSelectIds()
        if (this.current_edit_ids.length > 0) {
          this.handleDelete()
        } else {
          this.$message({ message: '请选择要进行删除的数据', type: 'warning' })
        }
      }
    },
    handleUpdate(actionType) {
      if (this.regroup_id == null) {
        this.$message({ message: '请选择分组', type: 'warning' })
        return false
      }
      if (this.listQuery.group_id === this.regroup_id && (this.rename_title === '' || this.rename_title === null)) {
        this.$message({ message: '分组相同，请重新选择分组', type: 'warning' })
        return false
      }
      // eslint-disable-next-line prefer-const
      let params = {
        ids: this.current_edit_ids,
        group_id: this.regroup_id
      }
      if (this.rename_title)params.original_name = this.rename_title
      api.Update(params).then(res => {
        this.rename_show = false
        this.regroup_show = false
        this.loadData()
        this.$message({ type: 'success', message: '修改成功!' })
      })
    },
    handleDelete() {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示').then(() => {
        api.Delete({ ids: this.current_edit_ids }).then(res => {
          this.loadData()
          this.$message({ type: 'success', message: '删除成功!' })
        })
      })
    },
    getSelectIds() {
      const selectIds = []
      this.list.forEach(ele => {
        if (ele.isChecked) { selectIds.push(ele.id) }
      })
      return selectIds
    },
    getSelectItems() {
      const selectItem = []
      this.list.forEach(ele => {
        if (ele.isChecked) { selectItem.push(ele) }
      })
      return selectItem
    },
    // 全选
    select_all() {
      // eslint-disable-next-line prefer-const
      let status = this.list.map(element => element.isChecked).findIndex(item => item === false)
      this.list.forEach(ele => {
        if (!ele.isChecked && status === -1) {
          this.$set(ele, 'isChecked', true)
        } else if (status !== -1) {
          this.$set(ele, 'isChecked', true)
        } else {
          this.$set(ele, 'isChecked', false)
        }
      })
    },
    clipboardSuccess() {
      this.$message({ message: '复制成功', type: 'success', duration: 1500 })
    }
    /*,
    generateSquareScaledImagePath(path) {
      const lastIndexOfSlash = path.lastIndexOf('/')
      return path.slice(0, lastIndexOfSlash + 1) + 's_s_' + path.slice(lastIndexOfSlash + 1, path.length)
    }*/
  }
}
</script>
<style lang="scss" scoped>
.list-container{
  padding-left: 20px;
  overflow: hidden;
  .list-item{
    padding: 0 15px;
    width: 200px;
    float: left;
    cursor: pointer;
    margin-bottom: 20px;
    .video_box{
      margin-left: 10px;
    }
    .image-pdf{
      background-image: url(/pdf.jpg);
      background-size: cover;
      background-position: center center;
    }
    .image-docx{
      background-image: url(/docx.png);
      background-size: cover;
      background-position: center center;
    }
    .image-xlsx{
      background-image: url(/xlsx.jpg);
      background-size: cover;
      background-position: center center;
    }
    .image-rar{
      background-image: url(/rar.jpg);
      background-size: cover;
      background-position: center center;
    }
    .image-zip{
      background-image: url(/zip.jpg);
      background-size: cover;
      background-position: center center;
    }
  }
  .list-item-audio{
    width: 264px;
    float: left;
    cursor: pointer;
    margin-bottom: 20px;
    margin-right: 60px;
    margin-top: 10px;
    .video_box{
      margin-left: 10px;
    }
  }
  .list-actions{
    clear: both;
    padding-bottom: 10px;
    margin-left: 25px;
  }
  .el-col{
    padding-bottom: 20px;
  }
  .actions{
    padding-top: 5px;
    .el-checkbox__label{ font-size: 12px;}
    overflow: hidden; color: #a9a9a9;
  }
}

</style>
